export class Constant {
}
Constant.ROOT = "/";
Constant.CONFIG_FILE_NAME = "adk-services.json";
Constant.BASE_URL = "";
Constant.WS_URL = "/v1/connect";
Constant.SSE_URL = "/v1/connect/sse";
Constant.LPOLL = "/v1/longpoll";
Constant.CONFIG_JSON_PATH = "/adk-services.json";
// update host file to point to specific ip to dev-art.com
